// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3Sam5","detailsBorder":"styles_detailsBorder__3EIJD"};